// src/utils/antdMessage.js
//
// Provides globally accessible antd v5 message, notification and modal
// instances that work outside of React components (utility files, etc.)
// and inside components without needing useApp() everywhere.
//
// Usage:
//   import { globalMessage } from 'src/utils/antdMessage'
//   globalMessage.success('Done!')
//   globalMessage.error('Something went wrong')
//   globalMessage.warning('Watch out')
//   globalMessage.info('FYI')
//   globalMessage.loading('Please wait...')

let _message    = null;
let _notification = null;
let _modal       = null;

export const setMessageInstance    = (instance) => { _message = instance; };
export const setNotificationInstance = (instance) => { _notification = instance; };
export const setModalInstance      = (instance) => { _modal = instance; };

export const globalMessage = {
  success: (...args) => _message?.success(...args),
  error:   (...args) => _message?.error(...args),
  warning: (...args) => _message?.warning(...args),
  warn:    (...args) => _message?.warning(...args),
  info:    (...args) => _message?.info(...args),
  loading: (...args) => _message?.loading(...args),
  destroy: (...args) => _message?.destroy(...args),
  open:    (...args) => _message?.open(...args),
};

export const globalNotification = {
  success: (...args) => _notification?.success(...args),
  error:   (...args) => _notification?.error(...args),
  warning: (...args) => _notification?.warning(...args),
  info:    (...args) => _notification?.info(...args),
  open:    (...args) => _notification?.open(...args),
  destroy: (...args) => _notification?.destroy(...args),
};

export const globalModal = {
  confirm: (...args) => _modal?.confirm(...args),
  info:    (...args) => _modal?.info(...args),
  success: (...args) => _modal?.success(...args),
  error:   (...args) => _modal?.error(...args),
  warning: (...args) => _modal?.warning(...args),
  destroyAll: () => _modal?.destroyAll(),
};